import { createContext } from "react";

export const ViewPromotionContext = createContext({
  viewPromotion: false,
  updateViewPromotion: () => {},
});
